<template>
  <i
    :class="{
      block: true,
      'h-[15px] w-2 rotate-45 border-b-[3px] border-r-[3px] border-www-color-primary-lighter': true,
    }"
  >
  </i>
</template>

<script lang="ts" setup></script>
